export default {
  VIEW_SELF_EMPLOYED_USER: "SelfEmployedUser",
  VIEW_TRADE_FEE_RATE: "TradeFeeRate",
  VIEW_USER_INDEX: "UserList",
  VIEW_SEARCH_IP: "SearchIp",
};
